// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"6bf925aa96de1b7265d5","532":"b5c82c35457896750319","678":"7f6d1d1258e567f868a4","883":"4c0771565953aec1a132"}[chunkId] + ".js";
};